import React from 'react';
import {connect} from 'react-redux';

import {TypeMap} from 'topmeteo/general/constants';
import {getColumn, getProduct} from 'topmeteo/general/selectors';

import {canPreload} from 'topmeteo/base-image/actionCreators';

import SwitchProduct from '../SwitchProduct';
import SwitchIndex from '../SwitchIndex';
import SwitchDate from '../SwitchDate';

import Loading from './Loading';
import MapImage from './MapImage';
import PinchZoom from './PinchZoom';
import BrowseLayer from './BrowseLayer';

import useDelayedLoading from './hooks';

const BrowseLayerOuter = ({type, url, isRequesting, isInteractive, startPreload, abortPreload, ...props}) => {
    const [loading, onLoad] = useDelayedLoading(url, isRequesting, isInteractive, startPreload, abortPreload);

    return (
        <div className="zoom browse-layer-outer">
            <PinchZoom id="content">
                <MapImage {...props} url={url} loading={loading} onLoad={onLoad} onUnload={abortPreload} />
            </PinchZoom>
            <BrowseLayer>
                <SwitchProduct />
            </BrowseLayer>
            {type === TypeMap && (
                <BrowseLayer>
                    <SwitchDate />
                </BrowseLayer>
            )}
            <BrowseLayer>
                <SwitchIndex />
            </BrowseLayer>
            {loading && <Loading />}
        </div>
    );
};

const mapStateToProps = state => {
    const {request, isAnimating, isDragging} = state;
    const {available, url} = getColumn(state);
    const {title} = getProduct(state);

    return {
        isRequesting: Boolean(request && request.immediate),
        isInteractive: Boolean(isAnimating || isDragging),
        url: available && url,
        title,
    };
};

const mapDispatchToProps = dispatch => ({
    startPreload: () => dispatch(canPreload(true)),
    abortPreload: () => {
        /* do not use implicit returning function
           or IE will show a confirmation pop up */
        dispatch(canPreload(false));
    },
});

export default connect(mapStateToProps, mapDispatchToProps)(BrowseLayerOuter);
